<template>
  <div class="set">
    <div v-if="loading">loading ...</div>
    <section class="set-container" v-else>
      <h1 class="set-heading">Your Fans</h1>
      <analytics v-if="paymentsSetup"/>
      <section class="callout" v-if="!hasFans">
        <p>Looks like you don't have any fans, yet! Everyone starts somewhere, all you have to do is share your landing page, and people will start signing up!</p>
        <p>Hey, try sharing this on Twitter, Instagram or Email.</p>
        <p><a :href="channelShareLink">Your share link</a></p>
      </section>
      <section class="fans" v-if="fans">
        <header class="fans-heading">
          <h1>Fan List</h1>
          <ff-button :text="'Export Fan Emails'" :action="downloadEmails" :pattern="2" :icon="'download'"/>
        </header>
        <cv-data-table class="dt" :columns="columns">
          <template slot="data">
            <cv-data-table-row
              class="dt-row"
              v-for="(fan, id) in fans"
              :key="`${id}`"
              :value="`${id}`"
            >
              <cv-data-table-cell class="dt-cell">
                <span>{{fan.email}}</span>
              </cv-data-table-cell>
              <cv-data-table-cell class="dt-cell">
                <span>{{fan.tier}}</span>
              </cv-data-table-cell>
            </cv-data-table-row>
          </template>
        </cv-data-table>
      </section>
    </section>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/storage'
import { mapState } from 'vuex'
import Analytics from './Analytics'
import FFButton from '../DesignSystem/FFButton'

export default {
  name: 'ChannelFans',
  components: {
    Analytics,
    'ff-button': FFButton
  },
  props: {
  },
  data () {
    return {
      columns: [
        'Email',
        'Tier'
      ]
    }
  },
  computed: {
    ...mapState(['user', 'channel', 'channel_id', 'fans']),
    loading () {
      return !this.user || !this.channel
    },
    hasFans () {
      return this.channel.fans
    },
    paymentsSetup () {
      return this.channel.tiers
    },
    channelShareLink () {
      return `${window.location.protocol}//${window.location.host}/share`
    },
  },
  methods: {
    async downloadEmails () {
      const ref = firebase.storage().ref().child('admin').child(this.user.uid).child('fans.csv');
      const url = await ref.getDownloadURL().catch((err) => console.error(err));

      window.open(url, '_blank');
    }
  },
  created () {
    this.$store.dispatch('fetchFans')
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/styles/app.scss";

  .set-container {
    max-width: $maxWidth--wide;
    margin: $unit-3 auto;
  }

  .set-heading {
    @include text('heading');
  }

  .set-subheading {
    @include caps;
  }

  .set-value {
    @include text('body');
    margin-bottom: $unit-2;
  }

  .dt {
    @include data-table;
  }

  .callout {
    @include callout("🙋‍♀️");

     p {
       margin-bottom: $unit-1;
     }
  }

  .fans-heading {
    display: flex;
    justify-content: space-between;
    align-items: center;

    h1 {
      @include text('strong');
      padding-bottom: .6rem;
    }
  }

</style>
